import { render, staticRenderFns } from "./ShowEditAddStep.vue?vue&type=template&id=08963a72&scoped=true&"
import script from "./ShowEditAddStep.vue?vue&type=script&lang=js&"
export * from "./ShowEditAddStep.vue?vue&type=script&lang=js&"
import style0 from "./ShowEditAddStep.vue?vue&type=style&index=0&id=08963a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08963a72",
  null
  
)

export default component.exports